import React from "react";
import { PropTypes } from "prop-types";
import styles from "./styles.css";
import ArrowIcon from "../../shared/arrow";

const ReadMore = ({onButtonClick, text, caretStyle = "styles.down", hasBorder}) => {
    return (
        <div styleName={hasBorder ? "styles.border styles.floatRight" : ""}>
            <a
                onClick={onButtonClick}
                styleName={"styles.readMore"}
            >{text} <span styleName={caretStyle}>
                    <ArrowIcon />
                </span>
            </a>
        </div>
    );
};

ReadMore.propTypes = {
    onButtonClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    caretStyle: PropTypes.string,
    hasBorder: PropTypes.bool
};

export default ReadMore;
